export const MAIN_BANNER_TYPE = 'prakerja_primary';
export const SECOND_BANNER_TYPE = 'prakerja_secondary';
export const COURSE_TYPE = {
  luring: 'Tatap Muka',
  webinar: 'Webinar',
  bauran_luring: 'Bauran Luring',
  bauran_daring: 'Bauran Daring',
  video_conference: 'Video Conference',
  self_paced: 'Pembelajaran Mandiri',
};
export const TNC_CHECKBOX_COPY = {
  webinar: 'Saya akan datang ke sesi webinar dan menyetujui',
  luring: 'Saya akan datang ke lokasi kelas tatap muka dan menyetujui',
};
export const TNC_CHECKBOX_FALLBACK = 'Saya akan mengikuti kelas dan menyetujui';
